import * as go from 'gojs/release/go-module';

import {
  LinkCategory,
  LinkLabelCategory,
  NodeCategory,
} from 'src/containers/ProjectDiagram/constants/categories';
import {
  MappingLabelNode,
  MappingLink,
  ModelConceptClassNode,
  ModelConceptRelationshipLabelNode,
  ModelConceptRelationshipLink,
  ResourceNode,
} from 'src/containers/ProjectDiagram/types/diagram';
import {
  isLink,
  isLinkLabel,
  isNode,
} from 'src/containers/ProjectDiagram/utils/graphObject';
import { getResourceValue } from 'src/containers/ProjectDiagram/utils/resource/createResource';
import { AppDispatch } from 'src/store/store';
import { ReduxStateGetter } from 'src/store/types';
import { EntityDrawerType } from 'src/store/ui/types';
import { uiSlice } from 'src/store/ui/ui.slice';

// this is a thunk action since memoized functions used for goJS
// templates do not get updated when props update, so it's best
// to use `getState` here to check the current (drawer) state instead
export const changeEntityDrawer =
  ({
    isDoubleClick = false,
    graphObject,
    projectId,
  }: {
    isDoubleClick?: boolean;
    graphObject: go.GraphObject;
    projectId: string;
  }) =>
  (dispatch: AppDispatch, getState: ReduxStateGetter) => {
    const { ui } = getState();

    if (!isDoubleClick && ui.entityDrawer.type === EntityDrawerType.NONE) {
      return;
    }

    if (
      isNode<ModelConceptClassNode>(
        graphObject,
        NodeCategory.MODEL_CONCEPT_CLASS
      )
    ) {
      dispatch(
        uiSlice.actions.changedEntityDrawer({
          projectId,
          drawer: {
            entityValue: graphObject.data.value,
            type: EntityDrawerType.CLASS,
          },
        })
      );
    } else if (isNode<ResourceNode>(graphObject, NodeCategory.RESOURCE)) {
      dispatch(
        uiSlice.actions.changedEntityDrawer({
          projectId,
          drawer: {
            entityValue: graphObject.data.value,
            type: EntityDrawerType.RESOURCE,
          },
        })
      );
    } else if (
      isLinkLabel<ModelConceptRelationshipLabelNode>(
        graphObject,
        LinkLabelCategory.MODEL_CONCEPT_RELATIONSHIP_LABEL
      )
    ) {
      const { labeledLink } = graphObject;

      if (!labeledLink) {
        return;
      }

      dispatch(
        uiSlice.actions.changedEntityDrawer({
          projectId,
          drawer: {
            entityValue: labeledLink.data.value,
            type: EntityDrawerType.RELATIONSHIP,
          },
        })
      );
    } else if (
      isLink<ModelConceptRelationshipLink>(
        graphObject,
        LinkCategory.MODEL_CONCEPT_RELATIONSHIP
      )
    ) {
      dispatch(
        uiSlice.actions.changedEntityDrawer({
          projectId,
          drawer: {
            entityValue: graphObject.data.value,
            type: EntityDrawerType.RELATIONSHIP,
          },
        })
      );
    } else if (
      isLink<MappingLink>(graphObject, LinkCategory.MAPPING) ||
      isLinkLabel<MappingLabelNode>(
        graphObject,
        LinkLabelCategory.MAPPING_LABEL
      )
    ) {
      dispatch(
        uiSlice.actions.changedEntityDrawer({
          projectId,
          drawer: {
            entityValue: getResourceValue(graphObject.data.from),
            type: EntityDrawerType.RESOURCE,
          },
        })
      );
    } else {
      dispatch(
        uiSlice.actions.changedEntityDrawer({
          projectId,
          drawer: {
            type: EntityDrawerType.NONE,
          },
        })
      );
    }
  };
